let mLink:any;
export function initLink(db){
    mLink = db.table('link');
}

/**
 * 更新
 * @param board
 */
export function updateLink(link){
    return mLink.put(link);
}

export function getLinkById(szLinkId){
    return mLink.get(szLinkId);
}

export function deleteLinkById(szLinkId){
    return mLink.delete(szLinkId);
}

/**
 * 获取收藏的
 */
export async function getLinkFavorList(){
    return mLink.where('isFavirated').equals(1).toArray();
}